export default class NotFoundError404 extends Error {
    constructor(message: string) {
        super(message);
    }
}
